/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable eqeqeq */
import React, { Fragment, useCallback, useEffect, useState, useRef, useMemo } from 'react';
import { Button, Divider, Dropdown, Input, Menu, Modal, Switch, Table, Tag, Tooltip } from 'antd';
import {
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  KeyOutlined,
  MenuOutlined,
  PlusOutlined,
  UserDeleteOutlined,
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import * as XLSX from 'xlsx';
import moment from 'moment';
import colorsDark from '../../../assets/colors/dark';
import * as SERVICE from '../../../constants/service.types';
import {
  NOTIFIES,
  DECODED_ACCESS_TOKEN,
  USER_TYPE_OPTIONS,
  ACCOUNT_STATUS,
} from '../../../constants/system.keys';
import * as ACTIONS from '../../../redux/actions';
import { openMessage, socketEmitEvent } from '../../../redux/actions';
import storageService from '../../../services/storage.service';
import { getExportReportsApi } from '../../../api/customerApi';
import { beeXLogger } from '../../../helpers/logger';
import AddMemberSteps from '../Modals/AddMemberSteps';
import UpdateMemberComponent from '../Modals/UpdateMember';
import ChangePasswordComponent from '../Modals/ChangePassword';
import { RemoveListMember } from '../Modals/RemoveListMember';

const { confirm } = Modal;
const { Search } = Input;

const memberRoleColors = (roleName) => {
  switch (roleName) {
    case 'admin':
      return colorsDark.$online;
    default:
      return colorsDark.$offline;
  }
};

const removeAccents = (str) => {
  return str
    ? str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/đ/g, 'd')
      .replace(/Đ/g, 'D')
    : '';
};

const MembersTab = ({
  namespace,
  localNamespace,
  isAdmin,
  currentTab,
  userId,
  onNavigateToGroup,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const {
    accountByNamespace,
    isAuth,
    updateMemberToNamespace,
    listDataSearch,
    removeMemberToNamespace,
    listGroupByAccount,
  } = useSelector(
    (state) => ({
      accountByNamespace: state.accountByNamespace,
      isAuth: state.isAuth,
      updateMemberToNamespace: state.updateMemberToNamespace,
      listDataSearch: state.listDataSearch,
      removeMemberToNamespace: state.removeMemberToNamespace,
      listGroupByAccount: state.listGroupByAccount,
    }),
    shallowEqual,
  );

  const [memberTabLoading, setMemberTabLoading] = useState(false);
  const [requestUpdateId, setRequestUpdateId] = useState(0);

  const [userGroupsCache, setUserGroupsCache] = useState({});
  const userGroupsCacheRef = useRef({});
  const pendingRequestsRef = useRef({});
  const requestIdMapRef = useRef({});
  const loadingTimeoutRef = useRef(null);

  const [displayedPage, setDisplayedPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const targetPageRef = useRef(1);
  const pageSizeRef = useRef(10);
  const isSearchModeRef = useRef(false);
  const accountByNamespaceDataRef = useRef([]);

  const [visibleEditMember, setVisibleEditMember] = useState(null);
  const [visibleChangePassword, setVisibleChangePassword] = useState(false);
  const [visibleAddMember, setVisibleAddMember] = useState(false);
  const [visibleRemoveListMember, setVisibleRemoveListMember] = useState(false);

  const [accountByNamespaceDataDefault, setAccountByNamespaceDataDefault] =
    useState();
  const [accountByNamespaceData, setAccountByNamespaceData] = useState({
    data: [],
    pagination: {},
    loading: false,
    total: 0,
  });

  const [expandedGroupAccounts, setExpandedGroupAccounts] = useState({});

  const toggleExpandGroups = (accountId) => {
    setExpandedGroupAccounts((prev) => ({
      ...prev,
      [accountId]: !prev[accountId],
    }));
  };

  const [dataMemberSearch, setDataMemberSearch] = useState();
  // const [key, setKey] = useState(Math.random());
  const [keyMember, setKeyMember] = useState(Math.random());
  const [isLoadingExport, setIsLoadingExport] = useState(false);
  const [fileData, setFileData] = useState([]);
  const [userType, setUserType] = useState('');

  const checkPageLoaded = (page, pSize, cache) => {
    const rawList = accountByNamespaceDataRef.current || [];
    if (!rawList || rawList.length === 0) return true;

    const startIdx = (page - 1) * pSize;
    const endIdx = page * pSize;
    const pageAccounts = isSearchModeRef.current
      ? rawList
      : rawList.slice(startIdx, endIdx);

    if (pageAccounts.length === 0) return true;

    const hasUnfinished = pageAccounts.some((acc) => {
      const accId = acc?.accountId;
      if (!accId) return false;
      const item = cache[accId];
      return !item || item.loading;
    });

    return !hasUnfinished;
  };

  const fetchGroupsForAccounts = useCallback((targetPage, targetSize) => {
    if (isAuth !== 1 || !namespace) return;

    const rawList = accountByNamespaceDataRef.current || [];
    if (!rawList || rawList.length === 0) return;

    const isSearchMode = isSearchModeRef.current;
    const pSize = targetSize || pageSizeRef.current || 10;
    const cPage = targetPage || targetPageRef.current || 1;

    const targetAccounts = isSearchMode
      ? rawList
      : (cPage <= 2
        ? rawList.slice(0, Math.max(cPage * pSize, 20))
        : rawList.slice((cPage - 1) * pSize, cPage * pSize));

    targetAccounts.forEach((acc) => {
      const accId = acc?.accountId;
      if (!accId) return;

      if (userGroupsCacheRef.current[accId] || pendingRequestsRef.current[accId]) {
        return;
      }

      const reqId = new Date().getTime() + Math.floor(Math.random() * 10000);
      pendingRequestsRef.current[accId] = reqId;
      requestIdMapRef.current[reqId] = accId;

      const nextCache = {
        ...userGroupsCacheRef.current,
        [accId]: { loading: true },
      };
      userGroupsCacheRef.current = nextCache;
      setUserGroupsCache(nextCache);

      const body = {
        namespace,
        accountId: Number(accId),
      };

      dispatch(
        socketEmitEvent({
          appServiceType: SERVICE.LIST_GROUP_BY_ACCOUNT,
          requestId: reqId,
          body: JSON.stringify(body),
        }),
      );
    });
  }, [isAuth, namespace, dispatch]);

  useEffect(() => {
    if (isAuth === 1 && namespace) {
      setMemberTabLoading(true);
      let data = {
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_ACCOUNT_BY_NAMESPACE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, isAuth, namespace]);

  useEffect(() => {
    if (accountByNamespace) {
      const dataTemp = accountByNamespace.map((acc, index) => ({
        ...acc,
        index: index + 1,
      }));
      setAccountByNamespaceData(dataTemp);
      setAccountByNamespaceDataDefault(dataTemp);
      accountByNamespaceDataRef.current = dataTemp;

      const isLoaded = checkPageLoaded(targetPageRef.current, pageSizeRef.current, userGroupsCacheRef.current);
      if (!isLoaded) {
        setMemberTabLoading(true);
        if (loadingTimeoutRef.current) clearTimeout(loadingTimeoutRef.current);
        loadingTimeoutRef.current = setTimeout(() => {
          setDisplayedPage(targetPageRef.current);
          setMemberTabLoading(false);
        }, 5000);
      } else {
        if (loadingTimeoutRef.current) clearTimeout(loadingTimeoutRef.current);
        setDisplayedPage(targetPageRef.current);
        setMemberTabLoading(false);
      }

      fetchGroupsForAccounts(targetPageRef.current, pageSizeRef.current);
    }
  }, [accountByNamespace, fetchGroupsForAccounts]);

  useEffect(() => {
    if (isAuth === 1 && namespace && userType) {
      let data = {
        namespace,
        userType,
      };

      let dataObjRole = {
        appServiceType: SERVICE.LIST_DETAIL_ROLE_OF_CUSTOMER,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObjRole));
    }
  }, [dispatch, isAuth, namespace, userType]);

  useEffect(() => {
    if (
      updateMemberToNamespace &&
      updateMemberToNamespace.requestId === requestUpdateId
    ) {
      const { result, data, message } = updateMemberToNamespace;
      if (result === -3) {
        openMessage(NOTIFIES.WARNING, message);
      }
      if (result === 1) {
        openMessage(NOTIFIES.SUCCESS, message);
        handleUpdateMemberDone(data);
      }
    }
  }, [updateMemberToNamespace]);

  useEffect(() => {
    if (removeMemberToNamespace && !visibleRemoveListMember) {
      if (removeMemberToNamespace?.result < 0) {
        openMessage(
          NOTIFIES.WARNING,
          removeMemberToNamespace.message
            ? removeMemberToNamespace.message
            : 'Remove member failed!',
        );
      } else {
        openMessage(
          NOTIFIES.SUCCESS,
          removeMemberToNamespace.message
            ? removeMemberToNamespace.message
            : 'Remove member successful!',
        );
      }
    }
    if (removeMemberToNamespace) {
      dispatch(ACTIONS.removeMemberToNamespaceReturn(null));
    }
  }, [removeMemberToNamespace, dispatch, visibleRemoveListMember]);

  useEffect(() => {
    if (dataMemberSearch) {
      const searchResults = Array.isArray(listDataSearch?.data) ? listDataSearch.data : [];
      setAccountByNamespaceData(searchResults);
      accountByNamespaceDataRef.current = searchResults;

      const isLoaded = checkPageLoaded(1, pageSizeRef.current, userGroupsCacheRef.current);
      if (!isLoaded) {
        setMemberTabLoading(true);
        if (loadingTimeoutRef.current) clearTimeout(loadingTimeoutRef.current);
        loadingTimeoutRef.current = setTimeout(() => {
          setDisplayedPage(1);
          setMemberTabLoading(false);
        }, 5000);
      } else {
        if (loadingTimeoutRef.current) clearTimeout(loadingTimeoutRef.current);
        setDisplayedPage(1);
        setMemberTabLoading(false);
      }

      fetchGroupsForAccounts(1, pageSizeRef.current);
    }
  }, [listDataSearch, dataMemberSearch, fetchGroupsForAccounts]);

  useEffect(() => {
    if (!listGroupByAccount) return;

    const reqId = listGroupByAccount.requestId;
    const accountId =
      listGroupByAccount.data?.accountId ||
      listGroupByAccount.data?.account_id ||
      requestIdMapRef.current[reqId];

    if (accountId) {
      let groupsList = [];
      const data = listGroupByAccount.data;
      if (Array.isArray(data)) {
        groupsList = data;
      } else if (Array.isArray(data?.groups)) {
        groupsList = data.groups;
      } else if (typeof data === 'object' && data !== null) {
        groupsList = Object.keys(data)
          .filter((k) => !isNaN(k) && data[k]?.id)
          .map((k) => data[k]);
      }

      delete pendingRequestsRef.current[accountId];

      const nextCache = {
        ...userGroupsCacheRef.current,
        [accountId]: {
          loading: false,
          groups: groupsList,
          raw: data,
        },
      };
      userGroupsCacheRef.current = nextCache;
      setUserGroupsCache(nextCache);

      if (checkPageLoaded(targetPageRef.current, pageSizeRef.current, nextCache)) {
        if (loadingTimeoutRef.current) clearTimeout(loadingTimeoutRef.current);
        setDisplayedPage(targetPageRef.current);
        setMemberTabLoading(false);
      }
    }
  }, [listGroupByAccount]);

  const onSearchMember = (name) => {
    setMemberTabLoading(true);
    const keyword = name?.trim() || '';
    targetPageRef.current = 1;

    if (keyword) {
      setDataMemberSearch(keyword);
      isSearchModeRef.current = true;
      const dataName = removeAccents(keyword.toLowerCase());
      const timestamp = new Date().getTime() / 1000;
      let data = {
        applicationType: 'account',
        input: dataName,
        page: 0,
        size: pageSizeRef.current || 10,
        namespace,
        providerNamespace: null,
        timeRequest: timestamp,
      };
      beeXLogger.debug('🚀 ~ onSearchMember ~ SEARCH_ADVANCE - body:', data);

      let dataObj = {
        appServiceType: SERVICE.SEARCH_ADVANCE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };

      dispatch(socketEmitEvent(dataObj));
    } else {
      setDataMemberSearch('');
      isSearchModeRef.current = false;
      setAccountByNamespaceData(accountByNamespaceDataDefault);
      accountByNamespaceDataRef.current = accountByNamespaceDataDefault || [];
      const isLoaded = checkPageLoaded(1, pageSizeRef.current, userGroupsCacheRef.current);
      if (isLoaded) {
        setDisplayedPage(1);
        setMemberTabLoading(false);
      } else {
        setMemberTabLoading(true);
        if (loadingTimeoutRef.current) clearTimeout(loadingTimeoutRef.current);
        loadingTimeoutRef.current = setTimeout(() => {
          setDisplayedPage(1);
          setMemberTabLoading(false);
        }, 5000);
        fetchGroupsForAccounts(1, pageSizeRef.current);
      }
    }
  };

  useEffect(() => {
    return () => {
      if (loadingTimeoutRef.current) {
        clearTimeout(loadingTimeoutRef.current);
      }
    };
  }, []);

  const onAddMember = (requestId, values) => {
    const {
      phonenumber,
      namespace,
      fullName,
      email,
      role,
      detailRoles,
      position,
      authMethod,
      username,
      password,
      enableWatermark,
      accountStatus,
      expireTime,
      externalUserId,
      allowIps,
    } = values;
    const normalizedExternalUserId =
      externalUserId === null || externalUserId === undefined
        ? ''
        : externalUserId.toString().trim();
    const data = {
      username,
      password,
      phonenumber,
      namespace,
      authMethod,
      fullName,
      email,
      role,
      detailRoles:
        (Array.isArray(detailRoles) ? detailRoles?.join(';') : detailRoles) ||
        '',
      expireTime: expireTime ? expireTime.format('YYYY-MM-DD HH:mm:ss') : '',
      enableWatermark: enableWatermark ? 1 : 0,
      accountStatus: accountStatus
        ? ACCOUNT_STATUS.ACTIVE
        : ACCOUNT_STATUS.BLOCKED,
      position: position || '',
      externalUserId: normalizedExternalUserId,
      allowIps:
        (Array.isArray(allowIps)
          ? allowIps?.filter((ip) => ip.trim() !== '')?.join(';')
          : allowIps) || '',
    };
    beeXLogger.debug('ADD_MEMBER - reqBody: ', data);
    const dataObj = {
      appServiceType: SERVICE.ADD_MEMBER,
      requestId,
      body: JSON.stringify(data),
    };
    return dispatch(socketEmitEvent(dataObj));
  };

  const onConfigTimeoutMember = (dataConfig) => {
    const { liveTimeout, accountId, namespace } = dataConfig;
    const data = {
      liveTimeout,
      accountId,
      namespace,
    };
    const dataObj = {
      appServiceType: SERVICE.CONFIGURATION_USER,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    return dispatch(socketEmitEvent(dataObj));
  };

  const onUpdateMember = (requestId, values) => {
    const {
      phonenumber,
      namespace,
      fullName,
      email,
      role,
      detailRoles,
      position,
      accountId,
      liveTimeout,
      username,
      password,
      authMethod,
      enableWatermark,
      accountStatus,
      expireTime,
      externalUserId,
      allowIps,
    } = values;
    setRequestUpdateId(requestId);
    const normalizedExternalUserId =
      externalUserId === null || externalUserId === undefined
        ? ''
        : externalUserId.toString().trim();

    let data = {
      phonenumber,
      namespace,
      fullName,
      email,
      role,
      detailRoles:
        (Array.isArray(detailRoles) ? detailRoles?.join(';') : detailRoles) ||
        '',
      position: position || '',
      username,
      password,
      authMethod,
      expireTime: expireTime ? expireTime.format('YYYY-MM-DD HH:mm:ss') : '',
      enableWatermark: enableWatermark ? 1 : 0,
      accountStatus: accountStatus
        ? ACCOUNT_STATUS.ACTIVE
        : ACCOUNT_STATUS.BLOCKED,
      externalUserId: normalizedExternalUserId,
    };

    if ('allowIps' in values) {
      data.allowIps =
        (Array.isArray(allowIps)
          ? allowIps?.filter((ip) => ip.trim() !== '')?.join(';')
          : allowIps) || '';
    }
    beeXLogger.debug('🚀 ~ UPDATE_MEMBER - onUpdateMember ~ data:', data);
    let dataObj = {
      appServiceType: SERVICE.UPDATE_MEMBER,
      requestId,
      body: JSON.stringify(data),
    };

    if (liveTimeout) {
      const dataObjConfig = {
        liveTimeout:
          moment(liveTimeout)?.hours() * 3600 +
          moment(liveTimeout)?.minutes() * 60,
        accountId,
        namespace,
      };
      onConfigTimeoutMember(dataObjConfig);
    }
    return dispatch(socketEmitEvent(dataObj));
  };

  const onResetPasswordMember = (requestId, values) => {
    beeXLogger.debug('RESET_USER_PASSWORD - values: ', values);
    const { accountId, password: newPassword, namespace } = values;

    let data = {
      accountId,
      namespace,
      newPassword,
    };
    beeXLogger.debug('RESET_USER_PASSWORD - data: ', data);

    let dataObj = {
      appServiceType: SERVICE.RESET_USER_PASSWORD,
      requestId,
      body: JSON.stringify(data),
    };
    return dispatch(socketEmitEvent(dataObj));
  };

  const handleAddMemberDone = useCallback(() => {
    setKeyMember(Math.random());
    if (isAuth === 1 && namespace) {
      setMemberTabLoading(true);
      let data = {
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_ACCOUNT_BY_NAMESPACE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, isAuth, namespace]);

  const onCloseModalAddMember = () => {
    setVisibleAddMember(false);
  };

  const handleUpdateMemberDone = useCallback(() => {
    setVisibleEditMember(null);
    if (isAuth === 1 && namespace) {
      setMemberTabLoading(true);
      let data = {
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_ACCOUNT_BY_NAMESPACE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, isAuth, namespace]);

  const handleResetPasswordMemberDone = useCallback(() => {
    setVisibleChangePassword(null);
  }, []);

  const onRemoveMember = useCallback(
    (record) => {
      confirm({
        title: `${t('Remove member with phone number as')} ${record.phonenumber}?`,
        icon: <ExclamationCircleOutlined />,
        okText: t('Remove'),
        onOk() {
          let data = {
            username: record.username,
            phonenumber: record.phonenumber,
            namespace,
          };
          let dataObj = {
            appServiceType: SERVICE.REMOVE_MEMBER,
            requestId: new Date().getTime(),
            body: JSON.stringify(data),
          };
          return dispatch(socketEmitEvent(dataObj));
        },
        onCancel() { },
      });
    },
    [dispatch, namespace, t],
  );

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) {
      return;
    }
    const reader = new FileReader();

    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];

      const jsonData = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
        raw: false,
        defval: '',
      });
      const formattedData = jsonData.slice(1).map((row) => ({
        phonenumber: row[0],
        namespace: namespace,
        fullName: row[1],
        email: row[2],
        position: row[3],
        role: row[4],
        detailRoles: row[5],
        username: row[6],
        password: row[7],
        externalUserId: row[8] ? row[8].toString().trim() : '',
      }));

      setFileData(formattedData);
    };

    reader.readAsArrayBuffer(file);
    e.target.value = '';
  };

  const submitFileUpload = () => {
    let index = 0;
    const interval = setInterval(() => {
      if (index < fileData.length) {
        const requestId = new Date().getTime();
        onAddMember(requestId, fileData[index]);
        index++;
      } else {
        clearInterval(interval);
      }
    }, 1000);
  };

  const onChangeAccountStatus = (checked, record) => {
    const requestId = new Date().getTime();
    setRequestUpdateId(requestId);
    const data = {
      accountStatus: checked ? ACCOUNT_STATUS.ACTIVE : ACCOUNT_STATUS.BLOCKED,
      username: record.username,
      namespace: record.namespace,
    };
    beeXLogger.debug('🚀 ~ UPDATE_MEMBER ~ data:', data);

    let dataObj = {
      appServiceType: SERVICE.UPDATE_MEMBER,
      requestId,
      body: JSON.stringify(data),
    };
    return dispatch(socketEmitEvent(dataObj));
  };

  // const onChangeEnableWatermark = (checked, record) => {
  //   const requestId = new Date().getTime();
  //   setRequestUpdateId(requestId);
  //   const data = {
  //     enableWatermark: checked ? 1 : 0,
  //     username: record.username,
  //     namespace: record.namespace,
  //   };

  //   let dataObj = {
  //     appServiceType: SERVICE.UPDATE_MEMBER,
  //     requestId,
  //     body: JSON.stringify(data),
  //   };
  //   return dispatch(socketEmitEvent(dataObj));
  // };

  const handleMemberTableChange = (pagination, filters) => {
    const newPage = pagination.current || 1;
    const newPageSize = pagination.pageSize || 10;
    targetPageRef.current = newPage;
    pageSizeRef.current = newPageSize;
    setPageSize(newPageSize);

    const hasSearchKeyword = Boolean(dataMemberSearch?.trim());

    if (filters) {
      setKeyMember(Math.random());
      let data = {
        namespace,
        status: filters?.['account_status']
          ? filters?.['account_status']?.[0]
          : null,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_ACCOUNT_BY_NAMESPACE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
      return;
    }

    if (hasSearchKeyword) {
      setKeyMember(Math.random());
      const timestamp = new Date().getTime() / 1000;
      let data = {
        applicationType: 'account',
        input: removeAccents(dataMemberSearch.trim().toLowerCase()),
        page: newPage - 1,
        size: newPageSize,
        namespace,
        providerNamespace: null,
        timeRequest: timestamp,
      };
      beeXLogger.debug('🚀 ~ handleMemberTableChange - SEARCH_ADVANCE ~ data:', data);
      let dataObj = {
        appServiceType: SERVICE.SEARCH_ADVANCE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    }

    const isLoaded = checkPageLoaded(newPage, newPageSize, userGroupsCacheRef.current);
    if (!isLoaded) {
      setMemberTabLoading(true);
      if (loadingTimeoutRef.current) clearTimeout(loadingTimeoutRef.current);
      loadingTimeoutRef.current = setTimeout(() => {
        setDisplayedPage(targetPageRef.current);
        setMemberTabLoading(false);
      }, 5000);
    } else {
      if (loadingTimeoutRef.current) clearTimeout(loadingTimeoutRef.current);
      setDisplayedPage(newPage);
      setMemberTabLoading(false);
    }

    fetchGroupsForAccounts(newPage, newPageSize);
  };

  const onDownloadMember = async () => {
    try {
      const token =
        storageService.getInternalStorageByKey(DECODED_ACCESS_TOKEN);

      const dataQuery = {
        namespace,
        customerNamespace: namespace,
        isDownload: 1,
      };

      const dataRes = await getExportReportsApi(
        token,
        { namespace: localNamespace },
        dataQuery,
      );

      if (!dataRes?.data) {
        ACTIONS.openMessage(NOTIFIES.WARNING, 'No data export');
        return;
      }

      const blob = new Blob([dataRes.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = 'report-members.xlsx';
      a.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      ACTIONS.openMessage(
        NOTIFIES.WARNING,
        error?.response?.data?.message ?? 'Something went wrong',
      );
    } finally {
      setIsLoadingExport(false);
    }
  };

  const columns = useMemo(
    () => [
      {
        title: t('Full name'),
        dataIndex: 'fullName',
        key: 'member_fullName',
        ellipsis: true,
        render: (text) => (
          <Tooltip title={text || null}>
            <span style={{ display: 'inline-block', maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {text || '-'}
            </span>
          </Tooltip>
        ),
        width: 150,
      },
      {
        title: t('Phone number'),
        dataIndex: 'phonenumber',
        key: 'member_phonenumber',
        width: 130,
        ellipsis: true,
        render: (text) => <span>{text || '-'}</span>,
      },
      {
        title: t('Email'),
        dataIndex: 'email',
        key: 'member_email',
        ellipsis: true,
        render: (emails) => {
          const emailText = emails?.split(';')?.join('; ') ?? '';
          return (
            <Tooltip title={emailText || null}>
              <span style={{ display: 'inline-block', maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {emailText || '-'}
              </span>
            </Tooltip>
          );
        },
      },
      {
        title: t('Position'),
        dataIndex: 'position',
        key: 'member_position',
        ellipsis: true,
        render: (position) => (
          <Tooltip title={position || null}>
            <span style={{ display: 'inline-block', maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {position || '-'}
            </span>
          </Tooltip>
        ),
      },
      {
        title: 'External Id',
        dataIndex: 'externalUserId',
        key: 'externalUserId',
        width: 100,
        ellipsis: true,
        render: (value) => (
          <Tooltip title={value || null}>
            <span style={{ display: 'inline-block', maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {value || '-'}
            </span>
          </Tooltip>
        ),
      },
      {
        title: t('UserType'),
        key: 'member_role',
        dataIndex: 'role',
        width: 120,
        render: (role) => {
          const label =
            USER_TYPE_OPTIONS.find((item) => item.value === role)?.label?.toUpperCase() || '-';

          return (
            <Tooltip title={label || null}>
              <Tag color={memberRoleColors(role)} style={{ marginRight: 0 }}>
                {label}
              </Tag>
            </Tooltip>
          );
        },
      },
      {
        title: t('Role'),
        key: 'member_detailRoles',
        dataIndex: 'detailRoles',
        render: (text) => {
          const roles = text
            ? text
              .split(';')
              .map((item) => item?.trim())
              .filter(Boolean)
              .map((item) => item.replaceAll('-', ' ').toUpperCase())
            : [];

          if (roles.length === 0) {
            return <span>-</span>;
          }

          const maxRoles = 2;
          const visibleRoles = roles.slice(0, maxRoles);
          const remainingRoles = roles.slice(maxRoles);

          return (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 4,
                flexWrap: 'nowrap',
              }}
            >
              {visibleRoles.map((role, index) => (
                <Tooltip title={role}>
                  <Tag
                    color={colorsDark.$online}
                    style={{
                      fontSize: '10px',
                      marginRight: 0,
                      maxWidth: 100,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {role}
                  </Tag>
                </Tooltip>
              ))}

              {remainingRoles.length > 0 && (
                <Tooltip
                  title={
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                      {remainingRoles.map((role, index) => (
                        <span key={index}>{role}</span>
                      ))}
                    </div>
                  }
                >
                  <Tag
                    style={{
                      fontSize: '10px',
                      marginRight: 0,
                      cursor: 'pointer',
                    }}
                  >
                    +{remainingRoles.length}
                  </Tag>
                </Tooltip>
              )}
            </div>
          );
        },
      },
      {
        title: t('Groups') || 'Groups',
        key: 'member_groups',
        render: (record) => {
          const accId = record.accountId;
          const cache = userGroupsCache[accId];

          if (!cache || cache.loading) {
            return <span>-</span>;
          }

          const groups = Array.isArray(cache.groups) ? cache.groups : [];

          if (groups.length === 0) {
            return <span>-</span>;
          }

          const leafGroups = groups.filter(
            (group) =>
              !groups.some((other) => other.parentGroupId === group.id),
          );

          const groupNames = leafGroups
            .map((g) => g.name || g.groupName || g.title)
            .filter(Boolean);

          if (groupNames.length === 0) {
            return <span>-</span>;
          }

          const isExpanded = !!expandedGroupAccounts[accId];
          const maxDisplay = 3;
          const remainingCount = groupNames.length - maxDisplay;

          if (isExpanded) {
            return (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, 1fr)',
                    gap: 4,
                    maxWidth: 360,
                  }}
                >
                  {groupNames.map((name, index) => (
                    <Tooltip
                      title={`${t('Click to view group')}: ${name}`}
                    >
                      <Tag
                        style={{
                          margin: 0,
                          cursor: 'pointer',
                          textAlign: 'center',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                        onClick={() => onNavigateToGroup && onNavigateToGroup(name)}
                      >
                        {name}
                      </Tag>
                    </Tooltip>
                  ))}
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                  <Tag
                    style={{
                      margin: 0,
                      cursor: 'pointer',
                      fontSize: 11,
                      backgroundColor: '#2b313a',
                      borderColor: '#434952',
                    }}
                    onClick={() => toggleExpandGroups(accId)}
                  >
                    {t('Collapse') || 'Thu gọn'}
                  </Tag>
                </div>
              </div>
            );
          }

          const visibleGroups = groupNames.slice(0, maxDisplay);

          return (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 4,
                flexWrap: 'nowrap',
              }}
            >
              {visibleGroups.map((name, index) => (
                <Tooltip
                  title={`${t('Click to view group')}: ${name}`}
                >
                  <Tag
                    style={{
                      marginRight: 0,
                      marginBottom: 0,
                      cursor: 'pointer',
                      maxWidth: 110,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                    onClick={() => onNavigateToGroup && onNavigateToGroup(name)}
                  >
                    {name}
                  </Tag>
                </Tooltip>
              ))}
              {remainingCount > 0 && (
                <Tooltip title={t('Click to view all')}>
                  <Tag
                    style={{
                      marginRight: 0,
                      marginBottom: 0,
                      cursor: 'pointer',
                      backgroundColor: '#2b313a',
                      borderColor: '#434952',
                    }}
                    onClick={() => toggleExpandGroups(accId)}
                  >
                    +{remainingCount}
                  </Tag>
                </Tooltip>
              )}
            </div>
          );
        },
      },
      {
        title: t('Active status'),
        key: 'account_status',
        width: 120,
        render: (record) => {
          const detailRolesArr = record.detailRoles?.split(';') || [];
          const isAdminDetailRole = detailRolesArr.some(
            (item) => item.split('-')?.[0] === 'admin',
          );
          const isRecordAdmin =
            record.role === 'admin' && isAdminDetailRole;
          return (
            <div>
              {(isAdmin || record.accountId === userId) &&
                !isRecordAdmin && (
                  <Tooltip
                    title={
                      record?.accountStatus === ACCOUNT_STATUS.ACTIVE
                        ? t('Available')
                        : t('Blocked')
                    }
                  >
                    <Switch
                      checked={
                        record?.accountStatus === ACCOUNT_STATUS.ACTIVE
                      }
                      onChange={(checked, event) =>
                        onChangeAccountStatus(checked, record)
                      }
                    />
                  </Tooltip>
                )}
            </div>
          );
        },
        filterMultiple: false,
        filters: [
          {
            text: t('Available'),
            value: ACCOUNT_STATUS.ACTIVE,
          },
          {
            text: t('Blocked'),
            value: ACCOUNT_STATUS.BLOCKED,
          },
        ],
      },
      {
        title: t('Expire time'),
        key: 'expire_time',
        dataIndex: 'expireTime',
        width: 150,
        ellipsis: true,
      },
      {
        title: t('Action'),
        key: 'actions ',
        width: 120,
        render: (record) => {
          const detailRolesArr = record.detailRoles?.split(';') || [];
          const isAdminDetailRole = detailRolesArr.some(
            (item) => item.split('-')?.[0] === 'admin',
          );
          const isRecordAdmin =
            record.role === 'admin' && isAdminDetailRole;

          const canEdit =
            (isAdmin || record.accountId === userId) && !isRecordAdmin;
          const canChangePassword = isAdmin && !isRecordAdmin;
          const canRemove = isAdmin && !isRecordAdmin;

          if (!canEdit && !canChangePassword && !canRemove) {
            return <span></span>;
          }

          const overlayMenu = (
            <Menu>
              {canEdit && (
                <Menu.Item
                  key="edit"
                  onClick={() => setVisibleEditMember(record)}
                >
                  <span>
                    <EditOutlined style={{ marginRight: 8 }} />
                    {t('Edit')}
                  </span>
                </Menu.Item>
              )}
              {canChangePassword && (
                <Menu.Item
                  key="change-password"
                  onClick={() => setVisibleChangePassword(record)}
                >
                  <span>
                    <KeyOutlined style={{ marginRight: 8 }} />
                    {t('Change password')}
                  </span>
                </Menu.Item>
              )}
              {canRemove && (
                <Menu.Item
                  key="remove"
                  onClick={() => onRemoveMember(record)}
                >
                  <span className="error">
                    <DeleteOutlined style={{ marginRight: 8 }} />
                    {t('Remove')}
                  </span>
                </Menu.Item>
              )}
            </Menu>
          );

          return (
            <div className="manager-member-actions">
              <Dropdown
                overlay={overlayMenu}
                trigger={['click']}
                placement="bottomRight"
              >
                <span className="edit-button">
                  <MenuOutlined style={{ marginRight: 4 }} /> {t('Option')}
                </span>
              </Dropdown>
            </div>
          );
        },
      },
    ],
    [
      t,
      userGroupsCache,
      expandedGroupAccounts,
      isAdmin,
      userId,
      onNavigateToGroup,
      onChangeAccountStatus,
      setVisibleEditMember,
      setVisibleChangePassword,
      onRemoveMember,
    ],
  );

  const dataSource = useMemo(() => {
    if (!accountByNamespaceData) return [];
    const list = Array.isArray(accountByNamespaceData)
      ? accountByNamespaceData
      : accountByNamespaceData?.data || [];
    return list.map((account) => ({
      ...account,
      key: account.index || account.accountId,
    }));
  }, [accountByNamespaceData]);

  return (
    <Fragment>
      <Modal
        width={700}
        visible={visibleAddMember}
        title={t('Add new member')}
        onCancel={() => {
          onCloseModalAddMember();
          setKeyMember(Math.random());
        }}
        footer={null}
      >
        {visibleAddMember && (
          <AddMemberSteps
            setUserType={setUserType}
            setFileData={setFileData}
            fileData={fileData}
            keyMember={keyMember}
            handleFileUpload={handleFileUpload}
            namespace={namespace}
            onAddMember={onAddMember}
            handleAddMemberDone={handleAddMemberDone}
            onConfigTimeoutMember={onConfigTimeoutMember}
            submitFileUpload={submitFileUpload}
            onCloseModalAddMember={onCloseModalAddMember}
          />
        )}
      </Modal>

      <Modal
        visible={visibleEditMember}
        width="620px"
        title={t('Edit member')}
        onCancel={() => setVisibleEditMember(null)}
        footer={null}
      >
        {visibleEditMember && (
          <UpdateMemberComponent
            namespace={namespace}
            onUpdate={onUpdateMember}
            data={visibleEditMember}
            setUserType={setUserType}
          />
        )}
      </Modal>

      <Modal
        visible={visibleChangePassword}
        title={`${t('Change password for')}: ${visibleChangePassword?.fullName}`}
        onCancel={() => setVisibleChangePassword(null)}
        footer={null}
      >
        {visibleChangePassword && (
          <ChangePasswordComponent
            namespace={namespace}
            onUpdate={onResetPasswordMember}
            onDone={handleResetPasswordMemberDone}
            data={visibleChangePassword}
          />
        )}
      </Modal>

      <Modal
        visible={Boolean(visibleRemoveListMember)}
        title={t('Remove list members')}
        onCancel={() => {
          setVisibleRemoveListMember(false);
          // setKey(Math.random());
        }}
        width={800}
        footer={null}
      >
        <RemoveListMember
          namespace={namespace}
          visible={visibleRemoveListMember}
          accountByNamespace={accountByNamespace}
        />
      </Modal>

      {currentTab === 'member' && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            paddingBottom: '5px',
          }}
        >
          <Search
            placeholder="Search..."
            onSearch={onSearchMember}
            style={{ width: 240, marginRight: '16px' }}
            allowClear
          />
          <Button
            onClick={() => setVisibleAddMember(true)}
            icon={<PlusOutlined />}
            type="primary"
          >
            {t('Add member')}
          </Button>
          <Button
            style={{ marginLeft: '16px' }}
            onClick={() => setVisibleRemoveListMember(true)}
            icon={<UserDeleteOutlined />}
          >
            {t('Remove members')}
          </Button>
          <Button
            style={{ marginLeft: '16px' }}
            loading={isLoadingExport}
            type="primary"
            onClick={() => {
              onDownloadMember();
              setIsLoadingExport(true);
            }}
            icon={<DownloadOutlined />}
          >
            {t('Download reports')}
          </Button>
        </div>
      )}

      <Table
        loading={memberTabLoading}
        pagination={{
          current: displayedPage,
          pageSize: pageSize,
          total: dataMemberSearch?.trim()
            ? (listDataSearch?.totalSize ?? 0)
            : (accountByNamespace?.length ?? 0),
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100', '200'],
        }}
        expandable={{
          expandedRowRender: (record) => {
            const { sessions } = record;
            return (
              <Fragment>
                {sessions.map((session, index) => (
                  <div className="session" key={index}>
                    <p>
                      <span>Client IP: </span>
                      {session.clientIp}
                    </p>
                    <p>
                      <span>Device: </span>
                      {session.deviceInfo}
                    </p>
                    <p>
                      <span>Online at: </span>
                      {session.onlineAt}
                    </p>
                    <Divider />
                  </div>
                ))}
              </Fragment>
            );
          },
          rowExpandable: (record) => record?.sessions?.length,
        }}
        columns={columns}
        dataSource={dataSource}
        onChange={handleMemberTableChange}
        scroll={{ x: 1350 }}
        className="members-table"
      />
    </Fragment>
  );
};

export default MembersTab;
